import type { GiftFields } from "@jti/store/utils";
import { isStandaloneGift } from "@jti/store/utils";

export const sortByStandaloneGifts = (a: GiftFields, b: GiftFields) => {
  return isStandaloneGift(a) === isStandaloneGift(b) ? 0 : isStandaloneGift(a) ? 1 : -1;
};
